var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThematicRegionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 10.2 L10.6 10.2 L10.6 14.6 L8.6 16.4 L5.4 15.6 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 10.2 L15.2 10.2 L16.6 12.4 L14.4 16.9 L10.6 14.6 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 15.6 L8.6 16.4 L9.6 19.4 L5.4 19.4 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 16.4 L14.4 16.9 L13.6 19.4 L9.6 19.4 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 10.2 L18.7 10.2 L18.7 15.5 L16.6 12.4 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThematicRegionsIcon);
export default __webpack_public_path__ + "static/media/thematic-regions-icon.b76a97faf4f26e9ce78ca1b86fd92829.svg";
export { ForwardRef as ReactComponent };